import React from 'react'
import { Archive, PencilLine } from '@phosphor-icons/react'
import { Dropdown } from 'antd'
import { Link } from 'react-router-dom'
import { useChangeCommunityStatus } from 'api/Community/CommunityCreation'
import ButtonSpinner from 'components/global/ButtonSpinner'

interface ManageButtonLeagueProps {
  id: string
  status?: string
}

const ManageButtonCommunity: React.FC<ManageButtonLeagueProps> = ({
  id,
  status,
}) => {
  const {
    mutate: changeCommunityStatusMutation,
    isLoading: changeCommunityStatusMutationLoading,
  } = useChangeCommunityStatus()

  const handleArchiveClick = () => {
    const payload = {
      status: status === 'archived' ? 'draft' : 'archived',
    }
    changeCommunityStatusMutation({ payload, communityId: id })
  }

  const items = [
    {
      key: 'edit',
      label: (
        <Link to={`/update-community/${id}`}>
          <div className="flex align-center">
            <PencilLine size={20} color="#000" />
            <h4 className="w-500 text-14 ml-10px">Edit Community</h4>
          </div>
        </Link>
      ),
    },
    {
      key: 'archive',
      label: (
        <div className="flex align-center">
          <Archive size={20} color="#000" />
          <h4 className="w-500 text-14 ml-10px" onClick={handleArchiveClick}>
            {status === 'archived' ? 'Unarchive' : 'Archive'} Community
          </h4>
        </div>
      ),
    },
  ]

  return (
    <Dropdown
      menu={{
        items: items,
      }}
      placement="bottomLeft"
      arrow={false}
      className="mr-10px "
      overlayStyle={{ width: '250px' }}
    >
      <button className="w-500 prim-sm-btn">
        {changeCommunityStatusMutationLoading ? (
          <ButtonSpinner size={20} color="#000" />
        ) : (
          'Manage Community'
        )}
      </button>
    </Dropdown>
  )
}

export default ManageButtonCommunity
